import React from 'react';
/**
 * Product description / care + compatibility notes block.
 * Self-contained text section.
 */
export function Description() {
  return <div className="space-y-4 text-gray-800 mb-12" data-id="element-347">
      <p data-id="element-348">The Gen2 E-Chest-Gear can be used in practice or at events.</p>
      <p data-id="element-349">
        This product requires a Gen2 E-chest gear transmitter to link up to Ring
        Manager System.
      </p>
      <p data-id="element-350">
        The Gen1 E-Chest gear Adapter Transmitters will allow you to use your
        gen1 e-chest gear with the Gen2 electronics.
      </p>
      <p className="text-xs text-gray-500 italic" data-id="element-351">
        Please store the e-hogu flat and when you ship the e-hogu, it should
        always be flat and never put on a non moving object
      </p>
      <p data-id="element-352">
        We recommend that you use Gen1 footgear with Gen1 system and Gen2
        footgear with Gen2 system.
        <br data-id="element-353" />
        Gen1 socks are not as sensitive on a Gen2 e-chest guard
        <br data-id="element-354" />
        You can not use Gen3 Daedo Socks on a Gen2 E-hogu.
      </p>
    </div>;
}